export default "__VITE_ASSET__Cqq6QcbH__"